import { render } from "./audioShare.vue?vue&type=template&id=6534326c&scoped=true"
import script from "./audioShare.vue?vue&type=script&lang=js"
export * from "./audioShare.vue?vue&type=script&lang=js"

import "./audioShare.vue?vue&type=style&index=0&id=6534326c&lang=scss&scoped=true"

import exportComponent from "/Users/liuli/Desktop/istory/vue3-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6534326c"]])

export default __exports__